










































































import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

@Component
export default class MentionsLegales extends Vue {
  @Getter('slug', {namespace: 'site'}) slug!: string;

  returnHome(): void {
    this.$router.back();
  }
}
